export default __webpack_public_path__ + "static/media/5-small.616dae48.png";